import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/new.css";
import { useNavigate } from "react-router-dom";
import LoadingBox from "../../components/LoadingBox";
import MessageBox from "../../components/MessageBox";
import Button from "../../components/Button";
import CenterModal from "../../components/modals/CenterModal";
import { createUser, resetUser } from "../../redux/slices/userSlice";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";

const NewUser = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password] = useState("DefaultPassword");
  const [isAdmin, setIsAdmin] = useState(false);

  const { userCreateSuccess, loading, error } = useSelector(
    (state) => state?.updateUser
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userCreateSuccess) {
      dispatch(resetUser());
      navigate("/users");
    }
  }, [dispatch, userCreateSuccess, navigate]);
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      createUser({
        firstName,
        lastName,
        dob,
        gender,
        phone,
        email,
        isAdmin,
        password,
      })
    );
  };

  return (
    <div className="">
      <div className="p-8">
        <div className="flex items-center justify-between">
          <p className="text-gray-500">
            <span className="text-xl">Add New User</span>
          </p>
        </div>

        <div className="">
          <div className="mt-8">
            {loading && (
              <CenterModal className="bg-transparent text-white">
                <LoadingBox />
              </CenterModal>
            )}
            {error && <MessageBox variant="danger">{error}</MessageBox>}
            {loading ? (
              <CenterModal className="bg-transparent text-white">
                <LoadingBox />
              </CenterModal>
            ) : error ? (
              <MessageBox variant="danger">{error}</MessageBox>
            ) : (
              <form onSubmit={submitHandler}>
                <div className="flex md:flex-row flex-col gap-4 mb-4">
                  <div className="w-full">
                    <label
                      htmlFor="firstName"
                      className="text-gray-600 mb-2 block"
                    >
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="Enter firstName"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>
                </div>
                <div className="flex md:flex-row flex-col gap-4 mb-4">
                  <div className="w-full">
                    <label
                      htmlFor="lastName"
                      className="text-gray-600 mb-2 block"
                    >
                      Last name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter last name"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>

                  <div className="w-full">
                    <label htmlFor="DOB" className="text-gray-600 mb-2 block">
                      DOB <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      id="DOB"
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                      placeholder="Enter DOB"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>
                </div>
                <div className="flex md:flex-row flex-col gap-4 mb-4">
                  <div className="w-full">
                    <label
                      htmlFor="gender"
                      className="text-gray-600 mb-2 block"
                    >
                      Gender <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="gender"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      placeholder="Enter gender"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>

                  <div className="w-full">
                    <label htmlFor="phone" className="text-gray-600 mb-2 block">
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Enter phone number"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>
                </div>
                <div className="flex md:flex-row flex-col gap-4 mb-4">
                  <div className="w-full">
                    <label htmlFor="email" className="text-gray-600 mb-2 block">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                      className="input-box focus:border-primary focus:ring-0"
                    />
                  </div>

                  <div className="w-full">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isAdmin}
                            onChange={(e) => setIsAdmin(e.target.checked)}
                          />
                        }
                        label="isAdmin"
                      />
                      <FormControlLabel
                        control={<Switch disabled />}
                        label="isVendor"
                      />
                    </FormGroup>
                    <p className="text-gray-500">password: DefaultPassword</p>
                  </div>
                </div>
                <div className="w-[200px]">
                  <Button
                    disabled={loading}
                    type="submit"
                    primary
                    className="w-full p-2"
                  >
                    {loading
                      ? '<i className="fa fa-spinner fa-spin"></i>'
                      : "Send"}
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUser;
